import { Component, Input } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { FlexModule } from '@angular/flex-layout';
import { IMedicalDeviceDetailed } from '../../../../../../../interfaces/MedicalDevice/IMedicalDeviceDetailed';

@Component({
  selector: 'app-medical-device-expand',
  standalone: true,
  templateUrl: './medical-device-expand.component.html',
  styleUrls: ['./medical-device-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, FlexModule],
})
export class MedicalDeviceExpandComponent {
  @Input() item: IMedicalDeviceDetailed = {};
}
